export const onTabButtonClick = (
  event,
  actualStep,
  pageNumber,
  disable,
  setActualStep,
  onStepChange
) => {
  event.preventDefault();
  if (onStepChange) {
    onStepChange(actualStep, pageNumber);
  }
  if (!disable) {
    setActualStep(pageNumber);
  }
};

export default {
  onTabButtonClick
};
